module.exports = __webpack_public_path__ + "src/assets/games/44/33.jpg";